module.exports = __webpack_public_path__ + "img/cardtest.e4224d21.svg";